import CodeStore from '@/pages/marketing/code-store'
import CouponCardUsedRecord from '@/pages/marketing/couponCardUsedRecord'
import ActivationList from '@/pages/marketing/activationList'
import ActivityRewardList from '@/pages/marketing/activityRewardList'
import ActivityList from '@/pages/marketing/activityList'
import ActivityRewardContentList from '@/pages/marketing/activityRewardContentList'
import ActivityManualReward from '@/pages/marketing/activityManualReward'
import ActivityEditView from '@/pages/marketing/activityEditView'
import ActivityDetailView from '@/pages/marketing/activityDetailView'
import PromoCodeList from '@/pages/marketing/promoCodeList'
import PromoCodeEdit from '@/pages/marketing/promoCodeEdit'
import MarketingExcludeRoom from '@/pages/marketing/marketingExcludeRoom'
import CouponCardList from '@/pages/marketing/coupon-card-list'
import Join from '@/pages/marketing/join'
import TagGroupList from '@/pages/marketing/tagGroupList'
import TagList from '@/pages/marketing/tagList'
import TagDetailList from '@/pages/marketing/tagDetailList'
import UserCouponManage from '@/pages/marketing/userCouponManage'

export const codeStore = {
  path: 'marketing/codeStore',
  component: CodeStore
}
// 卡劵使用记录
export const couponCardUsedRecord = {
  path: 'marketing/couponCardUsedRecord',
  component: CouponCardUsedRecord
}
// 关键字/激活码管理
export const activationList = {
  path: 'marketing/activationList',
  component: ActivationList
}
// 活动奖励管理
export const activityRewardList = {
  path: 'marketing/activityRewardList',
  component: ActivityRewardList
}
// 活动管理
export const activityList = {
  path: 'marketing/activityList',
  component: ActivityList
}
// 活动奖励内容列表
export const activityRewardContentList = {
  path: 'marketing/activityRewardContentList',
  component: ActivityRewardContentList
}
//手动赠送
export const activityManualReward = {
  path: 'marketing/activityManualReward',
  component: ActivityManualReward
}
// 标签组管理
export const tagGroupList = {
  path: 'marketing/tagGroupList',
  component: TagGroupList
}
// 标签管理
export const tagList = {
  path: 'marketing/tagList',
  component: TagList
}
// 标签明细
export const tagDetailList = {
  path: 'marketing/tagDetailList',
  component: TagDetailList
}
// 用户卡券管理
export const userCouponManage = {
  path: 'marketing/userCouponManage',
  component: UserCouponManage
}
// 编辑活动信息
export const activityEditView = {
  path: 'marketing/activityEditView',
  component: ActivityEditView
}
// 活动详情
export const activityDetailView = {
  path: 'marketing/activityDetailView',
  component: ActivityDetailView
}
// 优惠券管理
export const promoCodeList = {
  path: 'marketing/promoCodeList',
  component: PromoCodeList
}
// 新增/编辑优惠券
export const promoCodeEdit = {
  path: 'marketing/promoCodeEdit',
  component: PromoCodeEdit
}
// 房间不参与活动、卡券
export const marketingExcludeRoom = {
  path: 'marketing/marketingExcludeRoom',
  component: MarketingExcludeRoom
}
// 所有卡劵
export const couponCardList = {
  path: 'marketing/couponCardList',
  component: CouponCardList
}
// 加盟信息 - 业主加盟
export const join = {
  path: 'marketing/join',
  component: Join
}
// 加盟信息 - 区域战略合作
export const joinArea = {
  path: 'marketing/joinArea',
  component: Join
}


// WEBPACK FOOTER //
// ./src/router/marketing.js